module.exports = __webpack_public_path__ + "img/img_ticket_grayBG.b758f19c.png";